import themeColors, { themeFontsSize, themeFontWeights } from "@GeriMed/styles/variables";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { getBudget } from "@insite/client-framework/Services/BudgetService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentUserIsGuest, getIsPunchOutSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import cancelPunchOut from "@insite/client-framework/Store/Context/Handlers/CancelPunchOut";
import signOut from "@insite/client-framework/Store/Context/Handlers/SignOut";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import {
    getBudgetsDataView,
    getBudgetYears,
    getYearEnd,
} from "@insite/client-framework/Store/Data/Budgets/BudgetsSelectors";
import loadReviews from "@insite/client-framework/Store/Data/Budgets/Handlers/LoadReviews";
import { getShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import setIsReorderConfirmationModalOpen from "@insite/client-framework/Store/Pages/VmiBins/Handlers/SetIsReorderConfirmationModalOpen";
import setNextAction from "@insite/client-framework/Store/Pages/VmiBins/Handlers/SetNextAction";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden from "@insite/mobius/Hidden";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon/Icon";
import User from "@insite/mobius/Icons/User";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    const session = state.context.session;
    const isPunchOutSession = getIsPunchOutSession(state);
    const shipTo = getShipToState(state, session.shipToId).value;
    const currentUserIsGuest = getCurrentUserIsGuest(state);
    const sessionBillTo = getBillToState(state, state.context.session.billToId).value;
    const userName = state.context.session.userName;
    const isReorderConfirmationModalOpen = state.pages.vmiBins.isReorderConfirmationModalOpen;
    const hasChangeLastQty =
        state.pages.vmiBins.selectVmiBinsChangedQty &&
        Object.keys(state.pages.vmiBins.selectVmiBinsChangedQty).length > 0;
    const getBudgetParameter = state.pages.budgetManagement.getBudgetParameter;
    const budgetDataView = getBudgetsDataView(state, state.pages.budgetManagement.getBudgetParameter);
    return {
        session,
        shipTo,
        currentUserIsGuest,
        sessionBillTo,
        userName,
        isReorderConfirmationModalOpen,
        hasChangeLastQty,
        isPunchOutSession,
        getBudgetParameter,
        budgetDataView,
    };
};

const mapDispatchToProps = {
    signOut,
    cancelPunchOut,
    setIsReorderConfirmationModalOpen,
    setNextAction,
    loadReviews,
};
export interface HeaderSignInStyles {
    signOutWrapper?: InjectableCss;
    titleClickable?: ClickablePresentationProps;
    titleIcon?: IconPresentationProps;
    titleTypography?: TypographyPresentationProps;
    signOutClickable?: ClickablePresentationProps;
    submitButton?: LinkPresentationProps;
    mainContainer?: GridContainerProps;
    budgetChartGridItem?: GridItemProps;
    budgetProgressBar?: InjectableCss;
}

export const headerSignInStyles: HeaderSignInStyles = {
    submitButton: {
        css: css``,
    },
    mainContainer: {
        css: css`
            .available-bar {
                font-size: 15px;
                color: #363636;
                font-weight: 600;
                z-index: 2;
            }

            .budget-block {
                position: relative;
                background: #eee;
                border-radius: 8px;
                border: 2px solid #2f74b5;
                margin: 0 15px 0;
                width: 100%;
                display: flex;
                justify-content: space-between;
                padding: 4px 6px;
                z-index: 2;
                overflow: hidden;
            }

            .spent-bar {
                font-size: 15px;
                color: #fff;
                z-index: 2;
            }

            [class*="GridOffset"] {
                display: block;
                width: 100%;
                margin: 0;
            }

            .budget-table-wrap.active {
                background: #cbcbcb;
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        null,
                        null,
                        css`
                            max-width: 100%;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    signOutWrapper: {
        css: css`
            display: block;
            padding: 16px 0 0;

            .bold-text {
                font-weight: ${themeFontWeights.medium};
                color: ${themeColors.lightBlack};
                font-size: ${themeFontsSize.size14};
            }

            .company-name,
            .company-role {
                font-size: ${themeFontsSize.size14};
                padding: 0 8px;
            }

            .sign-out {
                display: block;
                margin: 16px 0;
            }

            svg {
                vertical-align: middle;
                margin-right: 10px;
            }
        `,
    },
    budgetChartGridItem: {
        width: 12,
        css: css`
            padding: 15px 0;
            max-width: 1015px;
            width: 100%;
            margin: 0 auto !important;
        `,
    },
    budgetProgressBar: {
        css: css`
            background: #2f74b5;
            position: absolute;
            height: 100%;
            width: 0;
            top: 0;
            left: 0;
            border-radius: 4px;
            z-index: 1;
        `,
    },
    titleClickable: {
        css: css`
            margin-left: 10px;
        `,
    },
    titleIcon: {
        size: 22,
    },
    titleTypography: {
        css: css`
            margin-left: 10px;
            max-width: 150px;
        `,
        ellipsis: true,
        transform: "uppercase",
    },
    signOutClickable: {
        css: css`
            flex: 0 0 auto;
            margin-left: 16px;
            text-transform: uppercase;
        `,
    },
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

let icon: React.ComponentType<IconPresentationProps>;

export const HeaderBudget = ({
    session,
    shipTo,
    currentUserIsGuest,
    sessionBillTo,
    userName,
    isReorderConfirmationModalOpen,
    hasChangeLastQty,
    setIsReorderConfirmationModalOpen,
    setNextAction,
    isPunchOutSession,
    cancelPunchOut,
    signOut,
    getBudgetParameter,
    loadReviews,
    budgetDataView,
}: Props) => {
    const styles = useMergeStyles("headerSignIn", headerSignInStyles);
    const isAuthenticated = session?.isAuthenticated && !session?.isGuest;
    const [currentFiscalYearBudget, SetCurrentFiscalYearBudget] = useState("");
    const [currentFiscalYearActual, SetCurrentFiscalYearActual] = useState("");
    const [currentFiscalYearVariance, SetCurrentFiscalYearVariance] = useState("");

    if (!budgetDataView.isLoading && !budgetDataView.value) {
        loadReviews(getBudgetParameter);
    }
    useEffect(() => {
        if (budgetDataView && budgetDataView.value) {
            const currentMonth = new Date().getMonth();

            budgetDataView.value.budgetLineCollection?.forEach(budgetLine => {
                if (budgetLine.period - 1 === currentMonth) {
                    if (budgetLine && budgetLine.currentFiscalYearBudgetDisplay) {
                        SetCurrentFiscalYearBudget(budgetLine.currentFiscalYearBudgetDisplay);
                    }

                    if (budgetLine && budgetLine.currentFiscalYearActualDisplay) {
                        SetCurrentFiscalYearActual(budgetLine.currentFiscalYearActualDisplay);
                    }
                    if (budgetLine.currentFiscalYearVarianceDisplay) {
                        SetCurrentFiscalYearVariance(budgetLine.currentFiscalYearVarianceDisplay);
                    }
                }
            });
        }
    }, [budgetDataView.value]);

    const customerInfoToggle = () => {
        const conditionCheck = document.querySelector(".customer-info-wrap");
        if (conditionCheck) {
            conditionCheck.classList.toggle("active", !conditionCheck.classList.contains("active"));
        }
    };

    const onSignOutHandler = () => {
        if (!isReorderConfirmationModalOpen && hasChangeLastQty) {
            setIsReorderConfirmationModalOpen({ isReorderConfirmationModalOpen: true });
            setNextAction({ nextAction: signOutFunc });
        } else {
            signOutFunc();
        }
    };

    const signOutFunc = () => {
        isPunchOutSession ? cancelPunchOut() : signOut();
    };
    const customCssWrapper = {
        css: css`
            .inf-cust > div,
            .inf-cust > div > div {
                display: inline-block;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            .company-name {
                                color: ${themeColors.lightBlack};
                                display: block;
                                margin-top: 8px;
                                font-size: ${themeFontsSize.size16};
                            }
                            .sign-out-wrapper {
                                .company-name,
                                .bold-text,
                                .company-role {
                                    font-size: ${themeFontsSize.size16};
                                }
                            }
                        `,
                    ],
                    "max",
                )}

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            button,
                            a.btn {
                                width: 100%;

                                span {
                                    font-size: ${themeFontsSize.size14};
                                }
                            }
                            .customer-info-wrap .change-customer {
                                display: block !important;
                            }
                            .m-10 {
                                margin: 10px 0;
                            }
                            .m-0 {
                                margin: 0;
                            }
                            .inf-cust > div,
                            .inf-cust > div > div {
                                display: block;
                            }
                            .company-name,
                            .bold-text,
                            .user-role {
                                font-size: ${themeFontsSize.size16};
                            }
                            .user-role {
                                font-size: ${themeFontsSize.size16};
                                margin-left: 8px;
                                font-style: italic;
                            }
                        `,
                    ],
                    "max",
                )}
        `,
    };

    function calculateRemainingBudgetPercentage(remainingBudgetStr: string, totalMonthlyBudgetStr: string): number {
        const remainingBudget: number = parseFloat(remainingBudgetStr.replace(/\$/g, ''));
        const totalMonthlyBudget: number = parseFloat(totalMonthlyBudgetStr.replace(/\$/g, ''));
    
        if (isNaN(remainingBudget) || isNaN(totalMonthlyBudget) || totalMonthlyBudget === 0) {
            return 0;
        }
    
        let percentageRemaining: number = (remainingBudget / totalMonthlyBudget) * 100;
        percentageRemaining = parseFloat(percentageRemaining.toFixed(2));
    
        return percentageRemaining;
    }

    const widthOfProgressBar = calculateRemainingBudgetPercentage(currentFiscalYearActual, currentFiscalYearBudget)

    return (
        <>
            {isAuthenticated && (
                <GridContainer {...styles.mainContainer}>
                    <StyledWrapper className="budget-table-wrap">
                        {currentFiscalYearBudget && (
                            <GridItem {...styles.budgetChartGridItem} className="budget-table budget-chart">
                                <StyledWrapper className="budget-block">
                                    <StyledWrapper {...styles.budgetProgressBar} className="progresssbar" style={{ width: `${widthOfProgressBar}%` }}></StyledWrapper>
                                    <Typography className="spent-bar">
                                        {currentFiscalYearActual} {translate("Spent")}
                                    </Typography>
                                    <Typography className="available-bar">
                                        {currentFiscalYearVariance} {translate("Available")}
                                    </Typography>
                                </StyledWrapper>
                            </GridItem>
                        )}
                    </StyledWrapper>

                    <StyledWrapper className="customer-info-wrap hide" {...customCssWrapper}>
                        <StyledWrapper>
                            <div className="customer-info">
                                <div className="inf-cust">
                                    <div className="m-10">
                                        <Typography as="span" className="inf-label">
                                            CUSTOMER #:
                                        </Typography>
                                        <Typography as="span" className="inf-value">
                                            {shipTo?.customerNumber}
                                        </Typography>
                                    </div>
                                    <div className="m-10">
                                        <div className="inf-label m-0">SHIP TO:</div>
                                        <Typography as="span" className="inf-value">
                                            {" "}
                                            {shipTo?.companyName}
                                        </Typography>
                                        {shipTo?.lastName &&
                                            shipTo?.firstName &&
                                            `${shipTo?.lastName} ${shipTo?.firstName}`}
                                        <Typography as="span" className="user-address">
                                            <span>{shipTo?.fullAddress}</span>
                                        </Typography>
                                    </div>
                                </div>
                                <div className="budget-table">
                                    <table className="info-tbl">
                                        <tbody>
                                            <tr>
                                                <th className="col-budget">Monthly Budget</th>
                                                <th className="col-budget spent">Budget Spent</th>
                                                <th className="col-budget left">Available Budget</th>
                                            </tr>
                                            <tr>
                                                <td className="col-budget">{currentFiscalYearBudget}</td>
                                                <td className="col-budgetspent">{currentFiscalYearActual}</td>
                                                <td className="col-budgetleft">{currentFiscalYearVariance}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="change-customer">
                                <Link
                                    href="/MyAccount/ChangeCustomer"
                                    className="btn btn-primary"
                                    id="tst_header_changeCustomer"
                                >
                                    Change Customer/Ship To
                                </Link>
                            </div>
                        </StyledWrapper>
                        <Hidden above="md">
                            <StyledWrapper className="sign-out-wrapper" {...styles.signOutWrapper}>
                                {session?.userLabel && !currentUserIsGuest && isAuthenticated && (
                                    <>
                                        <Typography onClick={customerInfoToggle} data-test-selector="header_userName">
                                            <User />
                                            <Typography as="span" className="bold-text">
                                                {session?.userLabel}
                                            </Typography>
                                            <Typography as="span" className="company-name">
                                                {sessionBillTo?.companyName}
                                                {session?.userRoles && (
                                                    <Typography as="span" className="company-role user-role">
                                                        ({session?.userRoles})
                                                    </Typography>
                                                )}
                                            </Typography>
                                        </Typography>
                                        {userName && !currentUserIsGuest && (
                                            <Clickable
                                                {...styles.signOutClickable}
                                                onClick={onSignOutHandler}
                                                data-test-selector="headerSignOutLink"
                                                className="btn btn-tertiary sign-out"
                                            >
                                                {isPunchOutSession
                                                    ? translate("Cancel PunchOut")
                                                    : translate("Sign Out")}
                                            </Clickable>
                                        )}
                                    </>
                                )}
                            </StyledWrapper>
                        </Hidden>
                    </StyledWrapper>
                </GridContainer>
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(HeaderBudget),
    definition: {
        displayName: "Header Budget",
        icon: "arrow-right-to-bracket",
        group: "Common",
    },
};

export default widgetModule;
